import React from 'react'
import _Select from 'react-select'
import CSelect from 'react-select/creatable'
import Label from './Input/Label'
import * as Str from './String'
import getStyles from './Select/styles.js'
import FieldError from './FieldError'
export const parseOptions = options => {
  if (Array.isArray(options)) {
    options = options.map(value => {
      if (value && typeof value === 'object') {
        return { ...value, value: value.value, label: value.label }
      }
      return { value: value, label: value }
    })
  } else if (typeof options === 'object') {
    options = Object.keys(options).map(k => ({ value: k, label: options[k] }))
  }
  return options
}

class Picklist extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hasValue: false
    }
  }

  onChange = (v, a) => {
    let { onCreate, onChange, onValueChange } = this.props
    if (onCreate && a.action === 'create-option') {
      onCreate(v, a)
    } else {
      onChange && onChange(v)
      onValueChange && onValueChange(v && v.value)
    }
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    let nextVal = nextProps.data || nextProps.value
    let hasVal = nextVal != null && ('' + nextVal).length
    if (hasVal) {
      return { hasValue: true }
    }
    if (prevState.hasValue && !hasVal) {
      return { hasValue: false }
    }
    return null
  }

  onKeyDown = (e) => {
    if (e.keyCode === 13 && this.select && this.select.select && this.select.select.menuListRef) {
      e.stopPropagation()
    }
  }

  getRef = ref => this.select = ref

  render () {
    const Select = this.props.isCreatable ? CSelect : _Select
    const { hasValue } = this.state
    let props = this.props
    let value = props.data || props.value
    let options = parseOptions(props.picklist || props.options || [])
    const selValue = options.find(o => o.value === value)
    return (
      <div className={`w-100 input-wrapper`}>
        <Label {...props} />
        <Select
          isSearchable={!props.config?.disableInput}
          openMenuOnFocus={this.props.openMenuOnFocus}
          ref={this.getRef}
          onKeyDown={this.onKeyDown}
          {...props}
          value={hasValue ? selValue : null}
          options={options}
          onChange={this.onChange}
          className={`input ${(this.props.required && !hasValue && `is-invalid`) || ''}`}
          isClearable={!this.props.disableClear}
          hasValue={!!selValue}
          menuPortalTarget={typeof document !== 'undefined' && document.body}
          components={{
            ...!props.icon && { DropdownIndicator: () => null },
            IndicatorSeparator: () => null, ...(this.props.components || {})
          }}
          placeholder={this.props.placeholder}
          styles={getStyles(this.props)}
          classNamePrefix={`react-select`}
          isDisabled={this.props.disabled}
          menuPlacement={`auto`}
          defaultMenuIsOpen={props.autoFocus || false}
        />
        <FieldError error={props.error} />
      </div>
    )
  }
}
export const Input = Picklist
export const Output = Str.Output
